import React from 'react';


const Footer = () =>{
    return(

        <>
         <footer className="footer">
 
     <hr className="p-0 m-0 b-0"/>
     <div className="bg-light py-2">
         <div className="container text-center">
             <p className="text-muted mb-0 py-2">© 2021 All rights reserved | Presented by : <a href="http://www.codelovertechnology.com/" style={{"textDecoration":"none"}} >CodeLover Technology</a></p>
         </div>
     </div>
 </footer>
        </>

    );
};

export default Footer;